import { render, staticRenderFns } from "./addArticleDialog.vue?vue&type=template&id=f4237816"
import script from "./addArticleDialog.vue?vue&type=script&lang=js"
export * from "./addArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./addArticleDialog.vue?vue&type=style&index=0&id=f4237816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports